<script setup lang="ts">
const { fetchContactInfo } = useContact()
await callOnce(fetchContactInfo)
</script>

<template>
  <div>

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
